<template>
  <div class="work-machine-selector">
    <div class="inner-wm-container">
      <div class="wm-container-request" v-if="requestedRemoteData">
        <div class="load text-center" v-if="loading">
          <loader :loading="loading" size="sm"/>
        </div>
        <div class="download-link c-pointer" @click="downloadFromApi" v-else>
          <i class="fa-solid fa-cloud-arrow-down"></i>
          Acutalizați datele prin API
        </div>
      </div>
      <div class="wm-container" v-else>
        <b-input-group class="search_filters">
          <b-input-group-prepend>
            <img src="@/assets/images/icons/search.svg" />
          </b-input-group-prepend>
          <b-form-input
              placeholder="Caută tractoare"
              v-model="searchValue"
          ></b-form-input>
        </b-input-group>
        <b-form-checkbox
            class="base_row select_all_link"
            @change="selectAllMachines($event)"
            v-model="selectedAll"
        >
          Selectează tot
        </b-form-checkbox>
        <div class="filter_separator"></div>

        <DxScrollView
            class="row_container"
            :use-native="true"
        >
          <div>
            <b-form-checkbox
                class="checkbox_row"
                v-for="(machine, index) in machines"
                :key="index"
                :value="machine.uuid"
                v-model="selectedMachines"
                @change="onSelectionChanged"
            >
              {{ machine.registration_number }}
            </b-form-checkbox>
          </div>
        </DxScrollView>
      </div>
    </div>
    <toast-message ref="toastMessage"></toast-message>
  </div>
</template>
<script>
import {DxScrollView} from "devextreme-vue/scroll-view";
import {mapActions, mapGetters} from "vuex";
import Loader from "@/components/Loader.vue";
import {handleError} from "@/helpers/generalActions";
import ToastMessage from "@/components/Mobile/toastMessage.vue";
export default {
  props:['sourceType', 'apiConfig'],
  name: 'WorkMachineSelector',
  data() {
    return {
      items: [],
      searchValue: '',
      radioModel: undefined,
      filters: {},
      selectedAll: false,
      selectedMachines: [],
      loading: false,
      wmDefaultParams: {
        enablePagination: 0,
        limit: 9999
      }
    }
  },
  components: {
    ToastMessage,
    Loader,
    DxScrollView,
  },
  computed: {
    ...mapGetters({
        workMachines: "works-work-machines/workMachines",
        tracktorApiVehicles: "importConfig/tracktorApiVehicles",
        tracktorApiProjects: "importConfig/tracktorApiProjects"
    }),
    requestedRemoteData() {
      return (this.items && this.items.length > 0 && this.machines.length === 0 && !this.searchValue);
    },
    machines() {
      let items = this.items;

      //filter for remote usage if set
      if (this.sourceType === 'remote') {
        items = this.items.filter((item) => {
          return Boolean(item.remote_id);
        })
      }

      console.log('filter machine', this.searchValue);

      return items.filter((obj) => {
            return obj.autopropulsat && !obj.is_dataller && obj.name
                .toUpperCase()
                .includes(this.searchValue.toUpperCase());
          }
      )
    }
  },
  methods: {
    ...mapActions({
        getWorkMachines: "works-work-machines/getWorkMachines",
        syncTracktorApiVehicles: "importConfig/syncTracktorApiVehicles",
        syncTracktorApiProjects: "importConfig/syncTracktorApiProjects",
        getSeasons: 'seasons/getSeasons'
    }),
    onSelectionChanged(selectedValues){
      const machines = selectedValues.map((machineUUID) => {
        return this.workMachines.find(wm => wm.uuid === machineUUID);
      });
      this.$emit('onSelectionChanged', machines);
    },
    selectAllMachines(selected) {
      this.selectedMachines = selected ? this.machines.map((item) => item.uuid) : [];
      this.onSelectionChanged(this.selectedMachines);
    },
    downloadFromApi() {
        const vm = this;
        this.loading = true;
        this.syncTracktorApiVehicles({
          import_configuration_uuid: this.apiConfig['uuid'] ?? null
        })
            .then((resp) => {
              this.getWorkMachines(this.wmDefaultParams).then((wms) => {
                vm.syncTracktorApiProjects({
                  import_configuration_uuid: this.apiConfig['uuid'] ?? null
                }).then((projects) => {
                  vm.getSeasons();
                });
              });
            })
            .catch((e) => {
                handleError(vm, e)
            })
            .finally(() => {
          vm.loading = false;
        })
    }
  },
  mounted() {
    this.getWorkMachines(this.wmDefaultParams);
  },
  watch: {
    workMachines: {
      handler: function (newVal) {
        this.items = newVal;
      },
      deep: true,
    }
  }
}
</script>

<style scoped>
.fa-cloud-arrow-down {
  font-size: 16px;
}

.download-link {
  color: #EA652A;
  text-align: center;
}
</style>
